import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { textRecipe } from './styles/text.styles';
import type { TextPropsInterface } from './types/text.types';

/**
 * @since 6.0.0
 */

export const Text = forwardRef<HTMLSpanElement, TextPropsInterface>(
  (props: TextPropsInterface, forwardedRef) => {
    const {
      asChild = false,
      className,
      color = 'text.neutral',
      css: cssProp,
      textStyle = 'body',
      ...rest
    } = props;

    const styles = css(textRecipe.raw({ color, textStyle }), cssProp);

    const Component = asChild ? Slot : 'span';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Text"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_text', 'c11n-semantic', styles, className)}
        {...rest}
      />
    );
  },
);

Text.displayName = 'Text';
